import styled from "@emotion/styled"
import CheckIcon from "@mui/icons-material/Check"
import * as api from "api"
import { memo } from "react"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    padding: 10px 15px;
  `,
  Headline: styled(Shared.Header)`
    text-align: left; // flipped for mui
    margin-top: 0;
  `,
  List: styled.ul`
    padding: 0;
    list-style: none;
    column-count: 3;
  `,
  ListItem: styled.li`
    display: flex;
    font-size: 1rem;
    padding: 0.4em 0;
    margin: 0;
    align-items: flex-start;
    line-height: 1.1;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
    svg {
      margin-inline-end: 10px;
      font-size: 1rem;
      color: ${(p) => p.theme.colors.duskBlue};
    }
  `,
}

type ServicesProps = { serviceCenter: api.SingleServiceCenter }

const Services = ({ serviceCenter }: ServicesProps) => {
  return (
    <Styled.Wrapper>
      <Styled.Headline variant="h2">השירותים שלנו</Styled.Headline>
      <Styled.List>
        {serviceCenter.services.map((item, i) => (
          <Styled.ListItem key={i}>
            <CheckIcon />
            {item}
          </Styled.ListItem>
        ))}
      </Styled.List>
    </Styled.Wrapper>
  )
}

export default memo(Services)
